// Persistence helpers for the Research-Window preset selection.
// Frontend-only. SSR/undefined-window safe. Whitelisted against the
// shipped RESEARCH_PRESETS list so a stale localStorage entry from
// a removed preset gracefully falls back to "custom".
import { RESEARCH_PRESETS } from "./researchPresets";

export const RESEARCH_PRESET_LS_KEYS = {
  backtest:    "researchPreset.backtest",
  walkforward: "researchPreset.walkforward",
};

const VALID_IDS = new Set(RESEARCH_PRESETS.map((p) => p.id));

export function loadResearchPreset(page, fallback = "custom") {
  try {
    if (typeof window === "undefined" || !window.localStorage) return fallback;
    const key = RESEARCH_PRESET_LS_KEYS[page];
    if (!key) return fallback;
    const raw = window.localStorage.getItem(key);
    if (!raw || !VALID_IDS.has(raw)) return fallback;
    return raw;
  } catch {
    return fallback;
  }
}

export function persistResearchPreset(page, id) {
  try {
    if (typeof window === "undefined" || !window.localStorage) return;
    const key = RESEARCH_PRESET_LS_KEYS[page];
    if (!key) return;
    if (!id || !VALID_IDS.has(id)) {
      // Unknown ids never get persisted — keeps the storage clean.
      return;
    }
    window.localStorage.setItem(key, id);
  } catch {
    /* swallow — persistence is best-effort */
  }
}
